import React from 'react';
import { FieldProps } from '@rjsf/core';

import { MultiFileUpload } from '../../FileUpload';
import { Media } from '../../../types';
import { getFileDetails } from '../../../utils';

const MultiFileUploadField = (props: FieldProps): JSX.Element => {
  const { formData, idSchema, schema, onChange, required, uiSchema, disabled, readonly } = props;
  const isRequired = uiSchema && !!uiSchema['ui:softRequired'] ? true : required;

  // Strip out filePath because Backend doesn't like writing to that field
  const value = formData
    ?.map((f: Media) => {
      return f.file
        ? {
            file: { fileUrn: f.file.fileUrn, fileRef: f.file.fileRef },
            addedAt: f.addedAt,
            path: f.file.filePath || f.path,
            nameAndType: f.file.filePath ? getFileDetails(f.file.filePath) : f.nameAndType,
          }
        : undefined;
    })
    .filter(Boolean);

  return (
    <MultiFileUpload
      id={idSchema.$id}
      label={schema?.title}
      onChange={onChange}
      value={value || []}
      required={isRequired}
      disabled={disabled || readonly}
    />
  );
};

export default MultiFileUploadField;
